// src/api/axiosSetup.js
import axios from "axios";

// BaseURL: mismo origen en producción; localhost en desarrollo
axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "" // en prod, usa el mismo dominio/puerto del backend
    : (process.env.REACT_APP_API_URL || "");

// Si usas cookies en autenticación, déjalo en true. Si no, puedes quitarlo.
axios.defaults.withCredentials = true;

// Reescribe URLs absolutas "locales" a rutas relativas, para no editar archivos viejos.
const LOCAL_HOST_RE = /^https?:\/\/(localhost|127\.0\.0\.1|10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+)(:\d+)?/i;

axios.interceptors.request.use((config) => {
  if (typeof config.url === "string" && LOCAL_HOST_RE.test(config.url)) {
    config.url = config.url.replace(LOCAL_HOST_RE, "");
    if (config.url && !config.url.startsWith("/")) {
      config.url = "/" + config.url;
    }
  }
  return config;
});

//Para que funcione en otros equipos ejecutar la linea de abajo en el Backend y cambiar el Port del server.js Backend
//$env:NODE_ENV="production"; node server.js
